module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-3-76137cf6da0481ad80f5312bd23cc2e5.jpg";